var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="form-horizontal">\n  <div class="form-group row">\n    <label class="col-sm-1 control-label">File</label>\n    <div class="col-sm-6">\n      <div data-mount="file-upload-dropzone"/>\n    </div>\n  </div>\n\n  ';
 if (downloadTemplateUrl) { 
__p+='\n    <div class="form-group row">\n      <div class="offset-1 col-sm-6">\n        <button class="btn btn-default" type="button" data-action="download-template">Download Template</button>\n      </div>\n    </div>\n  ';
 } 
__p+='\n\n  ';
 if (timeZoneConfig) { 
__p+='\n    <div class="form-group row">\n      <label class="col-sm-1 control-label">Timezone</label>\n      <div class="col-sm-3">\n        <div data-mount="timezone-picker"/>\n      </div>\n      <div class="col-sm-4">\n        <a data-help-popover="timezone-help-text-popover">Why is my timezone important?</a>\n      </div>\n    </div>\n  ';
 } 
__p+='\n</form>\n\n\n';
}
return __p;
};
